import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type NOM_221_2_SCFI_2018Props = {};

const NOM_221_2_SCFI_2018: React.FC<NOM_221_2_SCFI_2018Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='NOM-221/2-SCFI-2018'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10 max-w-[950px]">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-221/2-SCFI-2018
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "tech_spec_mobile_term",
                    defaultMessage: "Technical specifications of mobile terminal equipment that can make use of the radio spectrum or be connected to telecommunications networks. Part 2. Mobile terminal equipment operating in the 700 MHz, 800 MHz, 850 MHz, 1900 MHz, 1700 MHz/2100 MHz and/or 2500 MHz bands."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "tech_spec_mobile_term_2",
                    defaultMessage: "The products covered by this Official Mexican Standard are all those Mobile Terminal Equipment that can make use of the radio spectrum in the frequency bands of 700 MHz, 800 MHz, 850 MHz, 1900 MHz, 1700 MHz/2100 MHz and/or 2500 MHz or connected to telecommunications networks. Provided that when they operate, they do not cause harmful interference to other authorized operating equipment, nor to telecommunications networks and services authorized by the Federal Telecommunications Institute. The foregoing without prejudice to compliance with other applicable legal and administrative provisions."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "imei_devices",
                    defaultMessage: "Any device that can operate on the network with an IMEI code"
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "imei_devices_2",
                    defaultMessage: "Cell phones, tablets, routers or modems with access to the cellular network"
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/mobile-devices.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_221_2_SCFI_2018;